const PREFIX = 'CARRIERS_';

export const GET_CARRIERS_REQUEST = `${PREFIX}GET_CARRIERS_REQUEST`;
export const GET_CARRIERS_SUCCESS = `${PREFIX}GET_CARRIERS_SUCCESS`;
export const GET_CARRIERS_ERROR = `${PREFIX}GET_CARRIERS_ERROR`;
